import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { RawCollection, Collection } from '../types/models.ts';
import { ProductComplete } from '@/features/Product/types/models.ts';
import { useProductCompleteStore } from '@/features/Product/stores/productComplete.ts';

export const useCollectionStore = defineStore('collectionStore', () => {
  const cachedCollections = ref<RawCollection[]>([]);
  const setCachedCollections = (collections: RawCollection[]) => {
    cachedCollections.value = collections;
  };

  const selectedCollectionHandles = ref<string[]>([]);
  const setSelectedCollectionHandles = (collectionHandles: string[]) => {
    selectedCollectionHandles.value = collectionHandles;
  };

  const findCollectionByHandle = (handle: string) => {
    return cachedCollections.value.find((collection) => collection.handle === handle);
  };

  const completedProductStore = useProductCompleteStore();
  const collectionArray = computed<Collection[]>(() => {
    const collectionArrayDetails = cachedCollections.value.filter(({ handle }) =>
      selectedCollectionHandles.value.includes(handle),
    );
    return collectionArrayDetails.map((collection) => {
      const { seo, template, content } = collection;
      const productSourceCollection = collection.useProductsFromCollectionHandle
        ? findCollectionByHandle(collection.useProductsFromCollectionHandle)
        : collection;
      const productObjectArray =
        productSourceCollection?.productObjectArray || collection.productObjectArray;
      const products = productObjectArray.reduce<ProductComplete[]>((acc, { globalId }) => {
        const product = completedProductStore.getCompleteProduct('attributes.globalId', globalId);
        if (product) {
          acc.push(product);
        }
        return acc;
      }, []);
      return {
        seo,
        products,
        template,
        content,
      };
    });
  });

  return {
    cachedCollections,
    setCachedCollections,
    findCollectionByHandle,
    selectedCollectionHandles,
    setSelectedCollectionHandles,
    collectionArray,
  };
});
